export const validateAccountNumberFormat = (
  accountNumber: string
): { valid: boolean; message: string } => {
  if (!accountNumber) {
    return { valid: false, message: "Account number is required" };
  }

  if (accountNumber.length < 12) {
    return {
      valid: false,
      message: "Account number must be at least 12 digits",
    };
  }

  if (accountNumber.length > 13) {
    return {
      valid: false,
      message: "Account number must not exceed 13 digits",
    };
  }

  // Check if it contains only digits
  if (!/^\d+$/.test(accountNumber)) {
    return { valid: false, message: "Account number must contain only digits" };
  }

  return { valid: true, message: "" };
};

export const isAccountNumberValid = (accountNumber: string): boolean => {
  return validateAccountNumberFormat(accountNumber).valid;
};
